import { Component, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { filter, distinctUntilChanged } from 'rxjs/operators';

import { unsubscribe } from '@fcom/utils';

import { NavigationMenuService, ScrollService } from '../../services';
@Component({
  selector: 'fin-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: [],
})
export class BaseLayoutComponent implements OnDestroy {
  subscriptions: Subscription = new Subscription();
  isFooterOpen$: Observable<boolean>;

  constructor(
    private navigationMenuService: NavigationMenuService,
    private router: Router,
    private scrollService: ScrollService,
    @Inject(PLATFORM_ID) private platform: object
  ) {
    this.subscriptions.add(
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          filter(() => isPlatformBrowser(this.platform)),
          distinctUntilChanged((o: NavigationEnd, n) => o.url.split('?')[0] === n.url.split('?')[0]) // If path changed (not only parameters)
        )
        .subscribe(() => {
          this.scrollService.scrollTop();
        })
    );
    this.isFooterOpen$ = this.navigationMenuService.isFooterOpen$;
  }

  ngOnDestroy(): void {
    this.subscriptions = unsubscribe(this.subscriptions);
  }
}
